<template>
  <div class="batchEditGoods-container" v-loading="loading" element-loading-text="保存中">
    <div>
      <h2>商品管理 / 批量编辑</h2>
    </div>
    <!-- 表格 -->
    <div class="table-box">
      <el-table
        :data="selectSpuList"
        style="width: 100%; margin-bottom: 20px"
        row-key="goodsId"
        border
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column type="index" width="1">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu"> </template>
          </template>
        </el-table-column>
        <el-table-column label="商品名称" width="180">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <el-input size="mini" v-model="scope.row.name"></el-input>
            </template>
            <template v-else>
              <span>{{ scope.row.name }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column width="100">
          <template #header>
            <el-tooltip effect="dark" content="只对商品第一张图片进行管理" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
            &nbsp;商品图片
          </template>
          <template slot-scope="scope">
            &nbsp;
            <el-button size="mini" type="text" @click="previewPicClick(scope.row.picUrl)">预览</el-button> &nbsp; &nbsp;
            <el-upload
              :action="`${env.VUE_APP_fileserver}persistentUpload`"
              :show-file-list="false"
              :on-success="(res) => uploadSuccess(res, scope.row)"
              :before-upload="pictureBeforeUpload"
            >
              <el-button size="mini" type="text">更换</el-button>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column label="价格(元)" width="110">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">——</template>
            <template v-else>
              <el-input type="number" size="mini" v-model="scope.row.marketPriceStr"></el-input>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="单位" width="110">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">——</template>
            <template v-else>
              <el-select size="mini" filterable v-model="scope.row.mUnit" placeholder="请选择" @change="unitSelectChange">
                <el-option v-for="unitItem in scope.row.unitList" :key="unitItem.unitsCode" :label="unitItem.unitsName" :value="unitItem.unitsCode">
                </el-option>
              </el-select>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="库存" width="110">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">——</template>
            <template v-else>
              <el-input type="number" size="mini" v-model="scope.row.currQuantity"></el-input>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="分类" width="110">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <el-select size="small" v-model="scope.row.shopDecorateId" placeholder="选择分类" @change="shopDecorateIdChange">
                <el-option
                  v-for="cateItem in customCateList"
                  :label="cateItem.name"
                  :value="cateItem.shopDecorateId"
                  :key="cateItem.shopDecorateId"
                ></el-option>
              </el-select>
            </template>
            <template v-else>——</template>
          </template>
        </el-table-column>
        <el-table-column width="110">
          <template #header>
            <el-tooltip effect="dark" content="启用后，该商品只支持微信支付，您将承担千分之六的手续费" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
            &nbsp;微信支付
          </template>
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <el-switch v-model="scope.row.isAssumeWxFee" active-color="#1890ff" :active-value="1" :inactive-value="0"> </el-switch>
            </template>
            <template v-else></template>
          </template>
        </el-table-column>
        <el-table-column width="110">
          <template #header>
            <el-tooltip effect="dark" content="启用后，该商品支持银行卡支付，您将承担(储蓄卡千分之三/信用卡千分之六)的手续费" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
            &nbsp;银行卡支付
          </template>
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <el-switch v-model="scope.row.isAssumeCloudFee" active-color="#1890ff" :active-value="1" :inactive-value="0"> </el-switch>
            </template>
            <template v-else></template>
          </template>
        </el-table-column>
        <el-table-column label="配送模板" width="140">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <el-select v-model="scope.row.deliveryTemplateId" @change="deliveryTemplateIdChange">
                <el-option
                  v-for="deliveryModel in deliveryTemplateList"
                  :key="deliveryModel.id"
                  :label="deliveryModel.name"
                  :value="deliveryModel.id"
                ></el-option>
              </el-select>
            </template>
            <template v-else></template>
          </template>
        </el-table-column>
        <el-table-column label="运费模板" width="140">
          <template slot-scope="scope">
            <template v-if="scope.row.isSpu">
              <el-select v-model="scope.row.shopFreightTemplateId" @change="shopFreightTemplateIdChange">
                <el-option v-for="freightModel in freightFormworkList" :key="freightModel.id" :label="freightModel.name" :value="freightModel.id"></el-option>
              </el-select>
            </template>
            <template v-else></template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="bottom-box">
      <el-row type="flex" justify="center">
        <el-col :span="4">
          <el-button size="mini" @click="cancelBtnClick">取消</el-button>
          <el-button size="mini" type="primary" @click="sureBtnClick">确定</el-button>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="showPreviewImg" width="290px">
      <el-image style="width: 250px; height: 250px" :src="previewImgSrc" fit="cover"></el-image>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="showSaveDialog" width="300px">
      <span>您确定要保存当前设置吗？</span>
      <span slot="footer">
        <el-button size="mini" @click="showSaveDialog = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="saveSureBtnClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getGoodsShopCategory, getGoodsUnitByCategory, getGoodsDeliveryTemplate, getGoodsFreightFormwork } from "@/api/publishGoods/publishGoods";

import { goodsBatchModify } from "@/api/manageGoods/manageGoods";

export default {
  data() {
    return {
      env: process.env,
      selectSpuList: this.$route.params.selectSpuList, //选中的sku列表
      showPreviewImg: false, // 预览dialog
      showSaveDialog: false, // 保存dialog
      previewImgSrc: "", // 预览图片的地址
      customCateList: [], // 自定义分类
      deliveryTemplateList: [], // 配送模版
      freightFormworkList: [], // 运费模版
      loading: false,
    };
  },
  created() {
    this.loadGetGoodsShopCategory();
    this.loadGoodsDeliveryTemplate();
    this.loadGoodsFreightFormwork();
  },
  methods: {
    async loadGetGoodsShopCategory() {
      const result = await getGoodsShopCategory();
      this.customCateList = result.data;
      this.fromGoodsTypeToShopDecorateId();
    },
    async loadGoodsDeliveryTemplate() {
      const result = await getGoodsDeliveryTemplate();

      this.deliveryTemplateList = result.data;
    },
    async loadGoodsFreightFormwork() {
      const result = await getGoodsFreightFormwork();

      this.freightFormworkList = result.data;
    },
    unitSelectChange() {
      this.selectSpuList = [...this.selectSpuList];
    },
    deliveryTemplateIdChange() {
      this.selectSpuList = [...this.selectSpuList];
    },
    shopFreightTemplateIdChange() {
      this.selectSpuList = [...this.selectSpuList];
    },
    //通过自定义分类名称匹配自定义分类id
    fromGoodsTypeToShopDecorateId() {
      this.selectSpuList.forEach((item) => {
        if (item.goodsType) {
          const cateItemArr = this.customCateList.filter((cateItem) => cateItem.name == item.goodsType);
          if (cateItemArr.length) {
            item.shopDecorateId = cateItemArr[0].shopDecorateId;
          }
        }
      });
    },
    shopDecorateIdChange() {
      this.selectSpuList = [...this.selectSpuList];
    },
    async loadGoodsUnitByCategory() {
      const result = await getGoodsUnitByCategory();
      console.log(result.data);
    },
    //预览图片点击
    previewPicClick(picUrl) {
      this.showPreviewImg = true;
      this.previewImgSrc = picUrl;
    },
    uploadSuccess(res, obj) {
      const {
        data: { url },
      } = res;
      obj.picUrl = url;
    },
    pictureBeforeUpload(file) {
      const typeArr = ["image/png", "image/jpg", "image/jpeg"];

      if (!typeArr.includes(file.type)) {
        this.$message.error("上传图片只能是 JPG、PNG 格式!");
        return false;
      }

      if (file.size > this.sizeLimit * 1024 * 1024) {
        let unitStr = this.sizeLimit >= 1 ? `${this.sizeLimit}M` : `${this.sizeLimit * 1000}KB`;
        this.$message.error(`图片不能大于${unitStr}}`);
        return false;
      }
      this.isShowProgress = true;
      return true;
    },
    cancelBtnClick() {
      this.$router.back();
    },
    sureBtnClick() {
      this.showSaveDialog = true;
    },
    //确认保存
    async saveSureBtnClick() {
      this.loading = true;
      this.showSaveDialog = false;
      const spuVoList = [];

      this.selectSpuList.forEach((item) => {
        spuVoList.push({
          ...item,
          goodsId: "",
          picUrlList: [item.picUrl],
        });
      });

      const spuObj = { spuVoList };
      console.log("保存的数据", spuObj);
      try {
        this.loading = true;
        const result = await goodsBatchModify(spuObj);

        if (result.code != 0) {
          this.$message.error(result.msg || "保存失败");
        } else {
          this.$message.success("保存成功");
          this.$router.back();
        }
      } catch (error) {
        this.loading = false;
        this.$message.error("保存失败!");
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/views/seller/publishGoods/changeOuterMainColor.scss";
</style>

<style lang="scss" scoped>
@import "@/views/seller/publishGoods/changeMainColor.scss";
.batchEditGoods-container {
  padding: 20px;
  .table-box {
    margin-top: 20px;
    ::v-deep .el-table .cell {
      display: flex;
      align-items: center;
    }
  }
}
</style>
